<template>
    <div id="app">
        <aktarimdialog ref="aktarimdialog"></aktarimdialog>
        <v-card flat>
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" color="info">
                        <v-toolbar-title class="white--text">{{ $t('Ticket-Transfers') }}</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <a target="_self" v-bind:href="'#/bilet/yeni/id?'+'isl=yeni'">
                            <v-btn class="white--text" flat> {{ $t('New') }}
                                <v-icon right dark>add_circle_outline</v-icon>
                            </v-btn>
                        </a>

                    </v-toolbar>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 sm12>
                    <v-select hide-details="" :items="aktarimturu" clearable v-model="aktarimno" @change="dialogac(aktarimno)"
                        item-text="text" item-value="value" :label="$t('Choose-Transfer-Type')"></v-select>
                    <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid"
                        lazy-validation>
                        <v-container fluid="">
                            <v-layout row wrap>

                                <v-flex xs12 sm12>
                                    <label for="userfile">{{$t('Selected-File')}} :</label>
                                    <input type="file" multiple name="file" id="file" ref="file" v-on:change="handleFileUpload()">
                                    <v-btn color="info" flat @click="SubmitFile()">açvçaç </v-btn>

                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>

                </v-flex>
                <v-card flat>
                    <v-flex xs12 md6>
                    </v-flex>
                    <v-btn large="" color="info" @click="klasorcreate()">
                        <v-icon>search</v-icon>
                    </v-btn>

                    <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="500px">
                        <v-card color="grey lighten-2">
                            <v-card-title> {{ $t('Filter-selection') }} </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-layout row="" wrap="">
                                    <div class="flex md12">
                                        <cariaracomp v-bind:etiket="$t('Select-Current-Account')" v-bind:value="caridegeri" :loading="loading" v-model="caridegeri"></cariaracomp>
                                    </div>
                                </v-layout>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
                <v-container fluid>
                    <v-layout row wrap>

                    </v-layout>
                </v-container>
            </v-layout>
        </v-card>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
            :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>


    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
    import auth from '../../../api/auth'
    import tarihcomp from '../customcomp/tarihcomp'
    import aktarimdialog from "@/components/app/bilet/aktarimdialog.vue"
    import cariaracomp from '@/components/app/customcomp/cariaracomp'

    export default {
        data() {
            return {
                aktarimno: null,
                search1: '',
                caridegeri: null,
                dialogfiltre: false,
                loading: false,
                statecari: [],
                searchcari: '',
                renk1: 'info',
                date: null,
                menu: false,
                modal: false,
                dateFormatted: '',
                date2: null,
                menu2: false,
                dateFormatted2: '',
                modal2: false,
                harekettipi: '',
                items: [],
                itemsticket: [],
                StartDate: null,
                EndDate: null,
                load: false,
                load1: true,
                dialogmessage: '',
                dialog: false,
                progress: false,
                valid: true,
                snackbar: false,
                y: 'top',
                x: 'right',
                mode: '',
                timeout: 6000,
                text1: '',
                file1: '',
                file: []
            }
        },
        methods: {
            handleFileUpload() {

                var uploadedFiles = this.$refs.file.files;
                for (var i = 0; i < uploadedFiles.length; i++) {
                    this.file.push(uploadedFiles[i]);
                }
            },
            SubmitFile() {

                var cred = JSON.parse(window.localStorage.getItem('credentials'));
                let formData = new FormData();
                for (var i = 0; i < this.file.length; i++) {
                    let file = this.file[i];
                    formData.append('file[' + i +']', file);
                }
                formData.append('CustomerCode', cred.AnaSirketKodu)
                formData.append('TransferType', '0')
                axios.defaults.baseURL = auth.API_URL;
                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                axios.post(auth.API_URL + 'api/TicketDefinitons/FileUpload',
                        formData, {
                            headers: {
                                Authorization: `Bearer ${auth.getAuthHeader()}`
                            }
                        }
                    ).then(function () {

                    })
                    .catch(function () {

                    });
            },
            getDateNow: getDateNow,
            karsicariac: karsicariac,
            filtrekayit: filtrekayit,
            filtreiptal: filtreiptal,
            dialogac: dialogac,
            aktarimdeneme: aktarimdeneme,

            git: git
        },
        computed:{
            aktarimturu(){
                    return [{
                        text: 'Amadeus ' + this.$t('Transfer'),
                        value: '0'
                    },
                    {
                        text: 'THY İç Hat ' + this.$t('Transfer'),
                        value: '1',
                    },
                    {
                        text: this.$t('THY-Easy-Ticket-Report-Integration'),
                        value: '2'
                    },
                    {
                        text: this.$t('THY-Easy-Ticket-Sos-Agent-Integration'),
                        value: '3'
                    },
                    {
                        text: 'AtlasJet'  + this.$t('Transfer'),
                        value: '4'
                    },
                    {
                        text: 'Galileo',
                        value: '5'
                    },
                    {
                        text: 'SABRE ' + this.$t('Transfer'),
                        value: '6'
                    },
                    {
                        text: 'Pegasus ' + this.$t('Transfer'),
                        value: '7'
                    },
                    {
                        text: 'SunExpress ' + this.$t('Transfer'),
                        value: '8'
                    },
                    {
                        text: 'Onur Air ' + this.$t('Transfer'),
                        value: '9'
                    },
                    {
                        text: 'İDO ' + this.$t('Transfer'),
                        value: '10'
                    },
                    {
                        text: 'Turkuaz ' + this.$t('Transfer'),
                        value: '11'
                    },
                    {
                        text: 'Sky Air ' + this.$t('Transfer'),
                        value: '12'
                    },
                    {
                        text: 'WORLDSPAN ' + this.$t('Transfer'),
                        value: '13'
                    },
                    {
                        text: 'Arkman ' + this.$t('Transfer'),
                        value: '14'
                    },
                    {
                        text: 'Excel Dosyasından Bilet ' + this.$t('Transfer'),
                        value: '15'
                    },
                    {
                        text: 'IATI Bilet ' + this.$t('Transfer'),
                        value: '16'
                    },
                    {
                        text: 'Özel Excel Dosyadan Bilet ' + this.$t('Transfer'),
                        value: '17'
                    },
                    {
                        text: 'MHY ' + this.$t('Transfer'),
                        value: '18'
                    },
                    {
                        text: 'IATI Excel Dosyasından Bilet ' + this.$t('Transfer'),
                        value: '19'
                    },
                    {
                        text: 'Arkman XML ' + this.$t('Transfer'),
                        value: '20'
                    },
                    {
                        text: 'Borajet Bilet ' + this.$t('Transfer'),
                        value: '21'
                    },
                    {
                        text: 'BiletBank ' + this.$t('Transfer'),
                        value: '22'
                    },
                    {
                        text: 'BiletAll ' + this.$t('Transfer'),
                        value: '23'
                    }
                ]
                },
        },
        beforeMount: beforeMount,
        components: {
            aktarimdialog,
            'tarihcomp': tarihcomp,
            cariaracomp
        },
        watch: {
        },
    }

    function dialogac(aa) {
        this.$refs.aktarimdialog.open(aa).then(sonuc => {
            if (sonuc == true) {

            }

        });
    }



    function filtrekayit() {
        this.renk1 = 'orange darken-4'
        this.dialogfiltre = false
    }

    function filtreiptal() {
        this.renk1 = 'info'
        this.dialogfiltre = false
        this.caridegeri = null
        this.searchcari = null

    }

    function karsicariac() {
        this.dialog = false
        var url1 = '#/carihareketler/duzenle/id?' + 'ac=' + this.CariHareket.Account + '&dt=' + this.CariHareket.Date +
            '&on=' + this.CariHareket.OrderNumber
        window.open(url1, '_target')
    }


    function git(v) {
        if (v.GenelBilgileri.Status == 'S' || v.GenelBilgileri.Status == 'Ia') {
            var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v.GenelBilgileri
                .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
            window.open(url, '_target')
        } else if (v.GenelBilgileri.Status == 'V') {
            var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v.GenelBilgileri
                .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
            window.open(url, '_target')
        }
    }

    function beforeMount() {

    }



    function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }



    function aktarimdeneme() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        //  var file = new FormData($('#formaktarim')[0]);

        var form = document.getElementById('formaktarim');
        var formData = new FormData(form);


        //         var Params= {
        //           CustomerCode :credentials.SirketAdi,
        // TransferType :'0'
        //         }

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/FileUpload', file, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.itemsticket = response.body
            //this.items = response.body
            this.progress = false
            this.load1 = true
            this.load = false

        }, (response) => {
            if (response.status === 0) {
                this.error = 'Service Unavailable'
                this.load1 = true
                this.progress = false
                this.error = false
            } else {
                this.error = response.statusText
                this.load1 = true
                this.progress = false
                this.error = false

            }
        })


    }
</script>

<style>
</style>